import React from 'react';
import type { FC } from 'react';
import type { UserInfo } from '@wix/cli-auth';
import { Text } from '@wix/cli-ui-kit';
import { Unauthenticated } from './Unauthenticated.js';

interface Props {
  userInfo: UserInfo | null;
}

export const WhoamiCommand: FC<Props> = ({ userInfo }) => {
  if (userInfo == null) {
    return <Unauthenticated />;
  }

  return (
    <Text>
      Logged in as{' '}
      <Text skin="warning" bold>
        {userInfo.email}
      </Text>
    </Text>
  );
};
